module.exports = (terms) => {
    if (!terms || typeof terms !== 'string') {
        return 'student';
    }
    const preparedTerms = terms.toLowerCase().replace(/\s+/g, '');
    switch (preparedTerms) {
        case 'students&counselors':
            return 'student';
        case 'candidates&employers':
            return 'candidate';
        default:
            return 'user';
    }
};



// WEBPACK FOOTER //
// ./src/client/utils/getUserTitleByTerms.js